module.exports = __webpack_public_path__ + "6553a556caa2aec12488c5a9d9fdc2b7.MP3";